import React, { useCallback, useEffect, useState } from 'react';
import generatePriceRanges from '../helpers/generatePriceRanges';
import { useSearchParams } from 'react-router-dom';
import { number, bool } from 'prop-types';

import '../styles/ShopByPrice.css';
import ShopByPriceRange from './ShopByPriceRange';

const NUMBER_OF_RANGES = 5;

const ShopByPrice = ({ loading = false, productMaxPrice = 0 }) => {
    const [, setSearchParams] = useSearchParams();
    const [priceRanges, setPriceRanges] = useState([]);
    const onPriceRangeClick = useCallback((range) => {
        setSearchParams({
            minPrice: range.from,
            maxPrice: range.to,
        });
    }, [setSearchParams]);

    useEffect(() => {
        if (!isNaN(productMaxPrice) && parseInt(productMaxPrice) > 0) {
            const ranges = generatePriceRanges(productMaxPrice, NUMBER_OF_RANGES);
            setPriceRanges(ranges);
        } else {
            setPriceRanges([]);
        }
    }, [productMaxPrice]);
    return (
        <div
            className={'shop-by-price'}
        >
            <h5
                className={'shop-by-price--header'}
            >
                SHOP BY PRICE
            </h5>
            {loading && (
                <p
                    className={'shop-by-price--info-text'}>
                    Loading...
                </p>
            )}
            {(!loading && priceRanges?.length) ? <div
                className={'shop-by-price--ranges'}
            >
                {priceRanges.map((range) => (
                    <ShopByPriceRange
                        key={`${range.from}-${range.to}`}
                        range={range}
                        onPriceRangeClick={onPriceRangeClick}
                    />
                ))}
            </div> : null}
        </div>
    );
};

ShopByPrice.propTypes = {
    loading: bool,
    productMaxPrice: number,
};

export default ShopByPrice;